import "../styles/globals.css"
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"
import store, { persistor } from "../store/store"
import "@fontsource/inter"
import { LoadScriptNext } from "@react-google-maps/api"
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"
import { Initialiser } from "../components/Initialiser"
import CommonSidebar from "../components/CommonSidebar"
import { useRouter } from "next/router"
import dynamic from "next/dynamic"
const Toaster = dynamic(() => import("react-hot-toast").then((mod) => mod.Toaster), { ssr: false })

const libraries = ["places"]

function MyApp({ Component, pageProps }) {
  const router = useRouter()

  // Define public pages that don't need authentication
  const publicPages = [
    "/welcome",
    "/public-sites/[id]",
    "/login",
    "/register",
    "/reset-password",
    "/customer-signup",
    "/user-signup",
    "/cookies",
    "/privacy",
  ]
  const isPublicPage = publicPages.includes(router.pathname)

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <LoadScriptNext googleMapsApiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY} libraries={libraries}>
          <Toaster
            position="bottom-left"
            toastOptions={{
              success: {
                style: {
                  background: "green",
                },
              },
              error: {
                style: {
                  background: "#e15549",
                },
              },
            }}
          />
          <Initialiser />
          {isPublicPage ? (
            <Component {...pageProps} />
          ) : (
            <div className="flex flex-col h-screen">
              <Navbar />
              <div className="flex flex-row flex-grow overflow-y-scroll">
                <CommonSidebar title="sales" />
                <Component {...pageProps} />
              </div>
              <Footer />
            </div>
          )}
        </LoadScriptNext>
      </PersistGate>
    </Provider>
  )
}

export default MyApp
